import { useLazyLoadQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { useUnknownCareProviderQuery as useUnknownCareProviderQueryType } from "@/modules/care-provider/simple-search/services/__generated__/useUnknownCareProviderQuery.graphql"

const query = graphql`
  query useUnknownCareProviderQuery($skip: Boolean!) {
    ch_unknownCareProvider @skip(if: $skip) {
      id
    }
  }
`

export const useUnknownCareProviderQuery = ({ skip = false }) => {
  return useLazyLoadQuery<useUnknownCareProviderQueryType>(query, {
    skip,
  })
}
